import { format } from "date-fns";
import React from "react";
import Spinner from "react-bootstrap/Spinner";
// import { Collapse } from "react-collapse";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import OrderSummaryItems from "../../../../Common/Components/OrderSummaryItems";
import TotalPriceCard from "../../../../Common/Components/SummaryTotalPriceCard";
import { TitleHeader } from "../../../../Common/Components/TitleHeader";
import useTax from "../../../../Common/Hooks/useTax";
import {
  fetchServices,
  addOrder as storeOrderCreate,
} from "../../../Services/OrderService";
import { LuScanLine } from "react-icons/lu";
import { CiSquareMinus } from "react-icons/ci";
import { BsPlusSquare } from "react-icons/bs";

export const OrderReview = () => {
  const [loading, setLoading] = React.useState(false);
  const [deliveryTypes, setDeliveryTypes] = React.useState(null);
  const [services, setServices] = React.useState([]);
  const [items, setItems] = React.useState([]);
  const [submitting, setSubmitting] = React.useState(false);
  const [paymentMethod, setPaymentMethod] = React.useState("cash_on_delivery");
  const [open, setOpen] = React.useState({});
  const [sealNo, setSealNo] = React.useState("");
  const [childSeal, setChildSeal] = React.useState([]);

  const dts = useSelector((store) => store.OrderTypes);
  const orderTypeId = useSelector((x) => x.OrderTypeId);
  const bookingType = useSelector((x) => x.BookingType);
  const orderType = useSelector((x) => x.OrderType);
  const customerId = useSelector((x) => x.CustomerId);
  const processing = useSelector((x) => x.Processing);
  const cart = useSelector((x) => x.Cart);
  const date = useSelector((x) => x.Dates);
  const store = useSelector((x) => x.Store);
  const coupon = useSelector((x) => x.Coupon);
  const address = useSelector((x) => x.Addresses);
  const note = useSelector((x) => x.Note);
  const selfPick = useSelector((x) => x.SelfPick);
  const customer = useSelector((x) => x.Customer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [subtotal, tax, discount, deliveryCharge, total, grossTotal, referralDiscount] = useTax(
    deliveryTypes?.[orderTypeId]
  );

  const consumerRefCode = customer?.referral_reward?.consumer_referral_code;

  React.useEffect(() => {
    if (!cart || cart.length === 0) {
      navigate("/", { replace: true });
    }
  }, [cart, navigate]);

  React.useEffect(() => {
    setLoading(true);
    if (cart && cart.length > 0) {
      const r = dts.reduce((result, item) => {
        result[item.id] = item;
        return result;
      }, {});
      setDeliveryTypes(r);
      fetchServices(50, 1, orderTypeId).then(
        (res) => {
          setServices(res);
        },
        (err) => console.warn(err, "err while fetching services...")
      );
    } else navigate("/", { replace: true });
  }, [cart, navigate, dts, orderTypeId]);
  React.useEffect(() => {
    if (services.length !== 0 && cart.length !== 0) {
      setLoading(true);
      const temp = cart.reduce((result, item) => {
        const key = item.serviceId;
        setOpen((prev) => ({
          ...prev,
          [key]: true,
        }));
        if (!result[key]) {
          result[key] = {
            services_id: key,
            service: services.find((s) => s.id === key)?.name,
            open: true,
            items: [],
          };
        }
        const {
          laundry_item_id,
          laundry_item_category_id,
          price,
          quantity,
          bar_code,
          name,
          addons,
          is_bundle_active,
          bundle_free,
          free_items,
          bundle_buy,
          item_note,
        } = item;
        result[key].items.push({
          laundry_item_id,
          laundry_item_category_id: parseInt(laundry_item_category_id),
          price,
          quantity,
          bar_code,
          name,
          addons,
          free_items,
          bundle_free,
          bundle_buy,
          is_bundle_active,
          item_note,
        });
        return result;
      }, {});
      const tempTemp = Object.values(temp);
      const anotherTemp = [];
      for (let i = 0; i < tempTemp.length; i++) {
        const x = tempTemp[i];
        anotherTemp.push(x);
      }
      setItems(anotherTemp);
      setLoading(false);
    }
  }, [cart, services]);

  const clearNotes = () => {
  sessionStorage.removeItem("note");
  localStorage.removeItem("order_notes_saved_v1");
  };

  const afterOrder = (order) => {
    setSubmitting(false);
    try {
      const logs = JSON.parse(localStorage.getItem("_bt_logs") || "[]");
      logs.push({ order_id: order.order_id, booking_type: bookingType, flow: "old", time: new Date().toISOString() });
      if (logs.length > 500) logs.splice(0, logs.length - 500);
      localStorage.setItem("_bt_logs", JSON.stringify(logs));
    } catch {}
    navigate(`/store/orders/success/${order.order_id}`, {
      replace: true,
      state: { fromOrderPlacement: true },
    });
    clearNotes();
    // dispatch({ type: "setCart", payload: [] });
    // dispatch({ type: "setOrderType", payload: null });
    // dispatch({ type: "setOrderTypeId", payload: null });
    // dispatch({ type: "setBookingType", payload: null });
    // dispatch({ type: "setService", payload: null });
    // dispatch({ type: "setCategory", payload: null });
    // dispatch({ type: "setDeliveryDate", payload: null });
    // dispatch({ type: "setPickupDate", payload: null });
    // dispatch({ type: "setCoupon", payload: null });
    // dispatch({ type: "setAddresses", payload: null });
    // dispatch({ type: "setNote", payload: null });
    // dispatch({ type: "setSelfPick", payload: null });
  };
  const handlePlaceOrder = () => {
    if (!loading && items.length !== 0) {
      setSubmitting(true);

      let formattedNote = null;

      if (Array.isArray(note) && note.length > 0) {
        formattedNote = note;
      }

      const payloads = [
        {
          order_process: processing,
          seal_no: sealNo,
          child_seal_nos: childSeal.map(s => s.trim()).filter(Boolean),
          type: orderType,
          is_hub_store: selfPick === "false" || selfPick === false,
          user_id: customerId,
          payment_status: "unpaid",
          delivery_date: format(
            date?.delivery?.date,
            "yyyy-MM-dd HH:mm:ss.SSS"
          ),
          pickup_date: format(date?.pickup?.date, "yyyy-MM-dd HH:mm:ss.SSS"),
          payment_method: paymentMethod,
          isPay: paymentMethod === "up_front_cash_payment",
          platform: 4,
          consumer_referral_code: consumerRefCode,
          referral_discount: referralDiscount, 
          pickup_coordinates: address?.pickup_coordinates,
          destination_coordinates: address?.destination_coordinates,
          pickup_address: address?.pickup_address,
          destination_address: address?.destination_address,
          bar_code: "",
          order_pickup_time_slot_id: date?.pickup?.slot?.id,
          order_type_id: deliveryTypes?.[orderTypeId]?.id,
          order_delivery_time_slot_id: date?.delivery?.slot?.id,
          laundry_delivery_type_id: deliveryTypes?.[orderTypeId]?.id,
          service_id: 19,
          category_id: 1,
          delivery_charge: deliveryCharge,
          pickup_schedule: format(
            date?.pickup?.date,
            "yyyy-MM-dd HH:mm:ss.SSS"
          ),
          delivery_schedule: format(
            date?.delivery?.date,
            "yyyy-MM-dd HH:mm:ss.SSS"
          ),
          pending: "",
          distance: 10.5,
          note: formattedNote,
          // note: Array.isArray(note)
          //   ? note.length === 1
          //     ? note[0].note 
          //     : note.map(n => n.note) 
          //   : note || "",
          order_pickup_time_slot_date: format(
            date?.pickup?.date,
            "yyyy-MM-dd HH:mm:ss.SSS"
          ),
          order_delivery_time_slot_date: format(
            date?.delivery?.date,
            "yyyy-MM-dd HH:mm:ss.SSS"
          ),
          laundryZoneId: store?.zone_id,
          coupon_code: coupon?.coupon?.code,
          order_pickup_time_slot: `${date?.pickup?.slot?.start_time} - ${date?.pickup?.slot?.end_time}`,
          order_delivery_time_slot: `${date?.delivery?.slot?.start_time} - ${date?.delivery?.slot?.end_time}`,
          cart: items,
          tax_amount: tax,
          order_amount: total,
          booking_type: bookingType,
        },
      ];
      placeOrder(payloads);
    }
  };
  // const placeOrder = (payload) => {
  //   storeOrderCreate(payload).then(
  //     (res) => {
  //       afterOrder(res);
  //     },
  //     (er) => {
  //       setSubmitting(false);
  //       if (er && er.errors && er.errors.length !== 0) {
  //         console.warn(er);
  //         er.errors.forEach((x) => {
  //           toast.error(x.message);
  //         });
  //       }
  //     }
  //   );
  // };

  const placeOrder = (payload) => {
  storeOrderCreate(payload)
    .then((res) => {
      afterOrder(res);
    })
    .catch((er) => {
      setSubmitting(false);
      // console.log(`error`,er);
      
      const msg =
        er?.response?.data?.errors?.message ||
        er?.message ||
        "Something went wrong";

      alert(msg);

      if (er?.response?.data?.errors?.length) {
        er.response.data.errors.forEach((x) => {
          toast.error(x.message);
        });
      }
    });
};

  const norm = (s) => (s || "").trim();

  const master = norm(sealNo);

  const errs = (() => {
    const e = {};
    const seen = new Set();

    childSeal.forEach((v, i) => {
      const x = norm(v);
      if (!x) return;

      if (x.length < 6){
        e[i] = "Seal must be at Least 6 characters";
        return;
      }

      if (seen.has(x)) e[i] = "Duplicate child seal";
      else seen.add(x);

      if (master && x === master)
        e[i] = "Same as master seal not allowed";
    });

    return e;
  })();

  const addChild = () => setChildSeal((p) => [...p, ""]);
  const removeChild = (idx) => setChildSeal((p) => p.filter((_, i) => i !== idx));
  const updateChild = (idx, val) =>
  setChildSeal((p) => p.map((x, i) => (i === idx ? val : x)));
  const lastEmpty = childSeal.length && !norm(childSeal[childSeal.length - 1]);
  const hasErr = Object.keys(errs).length > 0;
  const inputRefs = React.useRef([]);
  const masterSealRef = React.useRef(null);
  const masterErr = master && master.length < 6 ? "Seal must be at least 6 characters" : "";
  const isSealInvalid =
  (master && master.length < 6) ||
  Object.keys(errs).length > 0;


  return (
    <>
      <TitleHeader
        title={"Order Review"}
        subtitle={
          "Double-check your details for a seamless, spotless laundry experience!"
        }
      />
      <div className="container">
        <div className="row justify-content-center py-4">
          <div
            className="col-xl-6 col-lg-7 col-md-10 col-12"
            style={{ minHeight: "80vh" }}
          >
            {loading ? (
              <div className="w-100 text-center py-3">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                <OrderSummaryItems
                  items={items}
                  open={open}
                  setOpen={setOpen}
                />
                <div className="card  mb-3">
                  {deliveryTypes ? (
                    <TotalPriceCard deliveryType={deliveryTypes[orderTypeId]} />
                  ) : null}
                </div>
                {/* Dates */}
                <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold mb-3 d-block">
                      Schedule Dates
                    </span>

                    <div className="app-dates-container border border-gray rounded mt-4 py-2 py-md-0">
                      <div className="col-12 col-md-5 px-4">
                        <small
                          style={{ position: "absolute", top: "-12px" }}
                          className="bg-white px-2"
                        >
                          Pickup
                        </small>
                        <div className="d-flex align-items-center py-3 border-r border-gray">
                          <i
                            className="fa-regular fa-calendar-plus me-3"
                            style={{ fontSize: "22px", color: "#666" }}
                          ></i>
                          {date.pickup.date
                            ? format(date.pickup.date, "eee, do MMM")
                            : "Date"}
                          {date.pickup.slot && date.pickup.date ? <br /> : "/"}
                          {date.pickup.slot
                            ? `${date.pickup.slot?.start_time} - ${date.pickup.slot?.end_time}`
                            : "Time"}
                        </div>
                      </div>
                      <div className="col-1 d-none d-md-block border-start border-gray h-100 py-2 border-2">
                        &nbsp;
                      </div>
                      <hr className="w-100 my-2 d-block d-md-none" />
                      <div className="col-12 col-md-5 px-4">
                        <small
                          style={{ position: "absolute" }}
                          className={`bg-white px-2 app-dates-delivery-label ${
                            !date.pickup.date && !date.pickup.slot ? "alt" : ""
                          }`}
                        >
                          Delivery
                        </small>
                        <div className="d-flex align-items-center py-3">
                          <i
                            className="fa-regular fa-calendar-plus me-3"
                            style={{ fontSize: "22px", color: "#666" }}
                          ></i>
                          {date.delivery.date
                            ? format(date.delivery.date, "eee, do MMM")
                            : "Date"}
                          {date.delivery.slot && date.delivery.date ? (
                            <br />
                          ) : (
                            "/"
                          )}
                          {date.delivery.slot
                            ? `${date.delivery.slot?.start_time} - ${date.delivery.slot?.end_time}`
                            : "Time"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Payment Method */}
                <div className="card  mb-3">
                  <div className="card-body">
                    <h5 className="fw-bold mb-3">Payment Method</h5>
                    <div
                      className="row cursor-pointer align-items-center py-3"
                      onClick={() => setPaymentMethod("cash_on_delivery")}
                    >
                      <div className="col-11 d-flex align-items-center justify-content-between h-100">
                        <div className="d-flex align-items-center">
                          <img
                            src={process.env.PUBLIC_URL + "/assets/images/cash-on-delivery.png"}
                            style={{
                              height: "48px",
                              width: "48px",
                              objectFit: "contain",
                            }}
                            className={`${
                              paymentMethod === "cash_on_delivery"
                                ? "selected-payment-method"
                                : ""
                            }`}
                            alt=""
                          />
                          <h6 className="ms-2 mb-0">Cash On Delivery</h6>
                        </div>
                        {paymentMethod === "cash_on_delivery" ? (
                          <img
                            src={process.env.PUBLIC_URL + "/assets/images/circle-check-solid.svg"}
                            style={{ width: "22px" }}
                            alt=""
                          />
                        ) : null}
                      </div>
                    </div>
                    <hr
                      className="border-1 my-0"
                      style={{ borderStyle: "doted" }}
                    />
                    <div
                      className="row cursor-pointer align-items-center py-3"
                      onClick={() => setPaymentMethod("card_on_delivery")}
                    >
                      <div className="col-11 d-flex align-items-center justify-content-between h-100">
                        <div className="d-flex align-items-center">
                          <img
                            src={process.env.PUBLIC_URL + "/assets/images/card-on-delivery.png"}
                            style={{
                              height: "48px",
                              width: "48px",
                              objectFit: "contain",
                            }}
                            className={`${
                              paymentMethod === "card_on_delivery"
                                ? "selected-payment-method"
                                : ""
                            }`}
                            alt=""
                          />
                          <h6 className="ms-2 mb-0">Card on Delivery</h6>
                        </div>
                        {paymentMethod === "card_on_delivery" ? (
                          <img
                            src={process.env.PUBLIC_URL + "/assets/images/circle-check-solid.svg"}
                            style={{ width: "22px" }}
                            alt=""
                          />
                        ) : null}
                      </div>
                    </div>
                    <hr
                      className="border-1 my-0"
                      style={{ borderStyle: "doted" }}
                    />
                    <div
                      className="row cursor-pointer align-items-center py-3"
                      onClick={() => setPaymentMethod("up_front_cash_payment")}
                    >
                      <div className="col-11 d-flex align-items-center justify-content-between h-100">
                        <div className="d-flex align-items-center">
                          <img
                            src={process.env.PUBLIC_URL + "/assets/images/card-on-delivery.png"}
                            style={{
                              height: "48px",
                              width: "48px",
                              objectFit: "contain",
                            }}
                            className={`${
                              paymentMethod === "up_front_cash_payment"
                                ? "selected-payment-method"
                                : ""
                            }`}
                            alt=""
                          />
                          <h6 className="ms-2 mb-0">Upfront Cash Payment</h6>
                        </div>
                        {paymentMethod === "up_front_cash_payment" ? (
                          <img
                            src={process.env.PUBLIC_URL + "/assets/images/circle-check-solid.svg"}
                            style={{ width: "22px" }}
                            alt=""
                          />
                        ) : null}
                      </div>
                    </div>
                    {/* <hr
                  className="border-1 my-0"
                  style={{ borderStyle: "doted" }}
                />
                <div
                  className="row cursor-pointer align-items-center py-3"
                  onClick={() => setPaymentMethod("digital_payment")}
                >
                  <div className="col-11 d-flex align-items-center justify-content-between h-100">
                    <div className="d-flex align-items-center">
                      <img
                        src={process.env.PUBLIC_URL + "/assets/images/digital-payment.png"}
                        style={{
                          height: "48px",
                          width: "48px",
                          objectFit: "contain",
                        }}
                        className={`${
                          paymentMethod === "digital_payment"
                            ? "selected-payment-method"
                            : ""
                        }`}
                        alt=""
                      />
                      <div className="ms-2">
                        <h6 className="mb-0">Digital Payment</h6>
                        <small>
                          Pay online now using credit or debit card
                        </small>
                      </div>
                    </div>
                    {paymentMethod === "digital_payment" ? (
                      <img
                        src={process.env.PUBLIC_URL + "/assets/images/circle-check-solid.svg"}
                        style={{ width: "22px" }}
                        alt=""
                      />
                    ) : null}
                  </div>
                </div> */}
                  </div>
                </div>
                {/* Addresses */}
                {/* Address */}
                <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold mb-3 d-block">Address</span>
                    <div
                      className="row cursor-pointer"
                      // onClick={() => setAddressModal("pickup")}
                    >
                      <div className="col-1 text-end pe-0">
                        <i
                          className="fa-solid fa-circle-dot"
                          style={{ color: "#32b6e9" }}
                        ></i>
                      </div>
                      <div className="col-11">
                        <h6 className="mb-1">Pickup Address</h6>
                        <p className="m-0">
                          {address?.pickup_address
                            ? `${address?.pickup_address?.addressLine1}, ${address?.pickup_address?.addressLine2}, ${address?.pickup_address?.area}, ${address?.pickup_address?.area_phase}`
                            : "Select address"}
                        </p>
                        <hr style={{ borderStyle: "doted" }} />
                      </div>
                    </div>

                    <div
                      className="row cursor-pointer"
                      // onClick={() => setAddressModal("delivery")}
                    >
                      <div className="col-1 text-end pe-0">
                        <i
                          className="fa-solid fa-location-dot text-primary"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="col-11">
                        <h6 className="mb-1">Delivery Address</h6>
                        <p className="m-0">
                          {address?.destination_address
                            ? `${address?.destination_address?.addressLine1}, ${address?.destination_address?.addressLine2}, ${address?.destination_address?.area}, ${address?.destination_address?.area_phase}`
                            : "Select address"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Note */}
                {note && note !== "" ? (
                  <div className="card  mb-3">
                    <div className="card-body">
                      <h5 className="fw-bold mb-3">
                        Order Note / Instructions.
                      </h5>
                      {/* <p>{note}</p> */}
                        <ul>
                          {(note || []).map((n, i) => <li key={n.id ?? i}>{n.note}</li>)}
                        </ul>
                    </div>
                  </div>
                ) : null}
                {/* Seal No. */}
                {/* {processing === "store" ? ( */}
                  <div className="card mb-3">
                    <div className="card-body">
                      <span className="fw-semibold mb-3 d-block">Seal No.</span>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          value={sealNo}
                          ref={masterSealRef}
                          onChange={(e) => setSealNo(e.target.value)}
                        />
                        <span
                          className="input-group-text"
                          role="button"
                          onClick={() => masterSealRef.current?.focus()}
                        >
                          <LuScanLine />
                        </span>
                      </div>
                      {masterErr && (
                        <small className="text-danger">{masterErr}</small>
                      )}
                      <div className="mt-3">
                          {childSeal.map((val, idx) => (
                            <div key={idx} className="d-flex align-items-center gap-2 mt-3">
                              <div className="input-group">
                                <input
                                  type="text"
                                  className={`form-control ${errs[idx] ? "is-invalid" : ""}`}
                                  ref={(el) => (inputRefs.current[idx] = el)}
                                  value={val}
                                  onChange={(e) => updateChild(idx, e.target.value)}
                                  placeholder={`Child seal ${idx + 1}`}
                                />
                                <span
                                  className="input-group-text"
                                  role="button"
                                  onClick={() => inputRefs.current[idx]?.focus()}
                                >
                                  <LuScanLine />
                                </span>
                                <span className="input-group-text" role="button" onClick={() => removeChild(idx)}>
                                  <CiSquareMinus />
                                </span>
                              </div>
                              {errs[idx] && <small className="text-danger">{errs[idx]}</small>}
                            </div>
                          ))}
                          <div className="mt-3 d-flex justify-content-center align-items-center gap-2">
                            <span className="fw-semibold">Add Child Seal</span>
                            <span role="button" onClick={addChild}>
                              <BsPlusSquare />
                            </span>
                          </div>
                        </div>
                    </div>
                  </div>
                {/* ) : null} */}
              </>
            )}
          </div>
        </div>
      </div>
      {!loading ? (
        <div className="container-fluid bg-white">
          <div
            className="row justify-content-center"
            style={{ padding: "20px 0px" }}
          >
            <div
              className="d-flex col-lg-6 col-md-7 col-12 justify-content-center"
              style={{ columnGap: "20px" }}
            >
              <button
                className="service-btn next"
                disabled={loading || submitting || hasErr || lastEmpty || isSealInvalid}
                // onClick={() => placeOrder()}
                onClick={() => {
                  if (!sealNo || sealNo === "") {
                    toast.error("Please add seal no. to continue.");
                    return;
                  } else handlePlaceOrder();
                }}
              >
                {submitting ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                ) : null}
                <span className="fw-semibold">Place Order</span>
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
